<template>
  <div class="detail">
    <course
      :id="id"
      ref="course"
      :key="id"
    />
  </div>
</template>
<script>
import { MBASVCAPIS, ACCOUNTAPIS } from '@api'
import course from './course'
export default {
  components: {
    course
  },
  props: {
    // 1: 课程; 2: 考试
    type: {
      type: [Number, String],
      default: 1
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      baseData: {},
      topInfo: [
        {
          label: '考试名称',
          value: '新手任务'
        },
        {
          label: '考试标签',
          value: null,
          isTag: true,
          tagData: []
        },
        {
          label: '总题数',
          value: 3
        },
        {
          label: '考试说明',
          value: ''
        },
        {
          label: '总分数',
          value: 100
        }
      ]
    }
  },
  methods: {
    init (id) {
      if (this.type === 1) {
        this.$refs.course.init({
          departmentIds: window.departmentIds,
          userIds: window.userIds
        })
      } else {
        this.$refs.exam.init({
          departmentIds: window.departmentIds,
          userIds: window.userIdLisddt
        })
      }
    },
    update (data) {
      if (this.type === 1) {
        this.$refs.course.init(data)
      } else {
        this.$refs.exam.init(data)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .detail {
    flex: 1;
    overflow-y: hidden;
    margin: 20px 0;
  }
</style>
